import { DEFAULT_TRANSITION_IN, DEFAULT_TRANSITION_OUT } from "../constants/AnimationConstants";
import AppConstants from "../constants/AppConstants";
import { ANIMATION_TYPE } from "../constants/MergeConstants";

const {
  BG_PROPERTY_MEDIA_TYPE,
  BG_TYPE_NONE,
  BG_PROPERTY_FILL_TYPE,
  BG_PROPERTY_BG_COLOR,
  BG_TYPE_COLOR,
} = AppConstants;

const Page = {
  id: "",
  type: "page",
  name: "New Page",
  slug: "new-page",
  pType: "site",
  pId: "",
  home: 0,
  mobile: {
    w: 320,
  },
  desktop: {
    w: 1200,
    [BG_PROPERTY_MEDIA_TYPE]: BG_TYPE_NONE,
    [BG_PROPERTY_FILL_TYPE]: BG_TYPE_COLOR,
    [BG_PROPERTY_BG_COLOR]: "colors-7",
  },
  sync: [
    BG_PROPERTY_FILL_TYPE,
    `${DEFAULT_TRANSITION_IN}.${ANIMATION_TYPE}`,
    `${DEFAULT_TRANSITION_OUT}.${ANIMATION_TYPE}`,
  ],
  blocks: [],
  blockData: {},
};

export default Page;
